import { useState } from 'react'
import useModal from '../../../Hooks/useModal'
import { PersonSimpleRun } from '@phosphor-icons/react'
import { COLOR_RED, GET_COLOR_BY_THEME } from 'constant/colors'
import { Loading } from 'Organisms/Loading'
import useSessionStore from 'Context/useSessionStore'

const BulkDeactivateUsersModal = ({ visible, setVisible, selectedUsers, reactivate, onConfirm }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))

  const { Modal, hide } = useModal({ identifier: 'bulkDeactivateUsers', visible, setVisible })
  const [submitting, setSubmitting] = useState(false)

  const names = selectedUsers.map((selectedUser) => `${selectedUser.firstname} ${selectedUser.lastname}`)
  const previewNames = names.slice(0, 3).join(', ')
  const remaining = names.length - 3
  const verb = reactivate ? 'reactivate' : 'deactivate'

  const handleSubmit = async () => {
    try {
      setSubmitting(true)
      await onConfirm()
      hide()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal>
      <>
        {submitting && <Loading />}

        <div className="modal-content" style={{ maxWidth: 500 }}>
          <div className="modal-body p-5">
            <div className="row justify-content-center">
              {reactivate
                ? (
                <PersonSimpleRun
                  style={{ transform: 'scaleX(-1)' }}
                  size={56}
                  color={GET_COLOR_BY_THEME({ theme: user.theme }).PRIMARY}
                  weight="bold"
                />
                  )
                : (
                <PersonSimpleRun size={56} color={COLOR_RED} weight="bold" />
                  )}
            </div>
            <div className="row justify-content-center py-4">
              <p className="text-center mb-1">
                Are you sure you want to {verb} {names.length} user{names.length > 1 ? 's' : ''}?
              </p>
              <p className="text-center text-quinary mb-3">
                {previewNames}
                {remaining > 0 ? ` and ${remaining} more` : ''}
              </p>
              <p className="text-center">
                {reactivate
                  ? 'We\'ll restore these users\' information and related data to the system.'
                  : 'We\'ll still keep these users\' information and related data.'}
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-auto">
                <button type="button" className="btn btn-secondary mr-2" onClick={hide}>
                  Cancel
                </button>
              </div>
              <div className="col-auto">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={`btn ${reactivate ? 'btn-primary' : 'btn-danger'}`}>
                  {reactivate ? 'Reactivate' : 'Deactivate'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default BulkDeactivateUsersModal
